<template>
<div>
  <div class="mdgridviewpage-bg mainWrap-bg applicationListPage">
    <div class="container-fluid maindivWrap pt-4">
      <div class="row">
        <div class="col-12">
          <div class="row mx-0">
            <div class="col-sm-4">
              <div v-if="allAppsList.length > 0">
                <form>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-search" aria-hidden="true"></i>
                      </span>
                    </div>
                    <input type="text" class="form-control" placeholder="Search..." id name v-model="searchName" style="border-left:0;" />
                  </div>
                </form>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="d-flex" style="justify-content: flex-end;">
                <div class="mx-2" v-if="(isAdmin || isAppAdmin) && canCreateApp">
                  <div class="createSection">
                    <div class="form-group selectModule">
                      <select class="form-control" id="sel1" v-model="appType">
                        <option value="dashboard">Dashboard</option>
                        <option value="eLearning">E-Learning</option>
                      </select>
                    </div>
                    <b-button variant="success" class="text-white" size="sm" @click="createApp">
                      <i class="fa fa-file-excel-o pr-2 text-white" aria-hidden="true"></i>
                      Create
                    </b-button>
                  </div>
                </div>
                <div class="mx-2">
                  <a type="button" class="btn btn-light btn-sm viewBtn" href="javascript:void(0)" @click.stop.prevent="isView = 'grid'" :class="{'active': isView === 'grid'}" v-b-tooltip.hover title="Grid View">
                    <i class="fa fa-th-large" aria-hidden="true"></i>
                  </a>
                </div>
                <div class="mx-2">
                  <a type="button" class="btn btn-light btn-sm viewBtn" href="javascript:void(0)" @click.stop.prevent="isView = 'list'" :class="{'active': isView === 'list'}" v-b-tooltip.hover title="Table View">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </a>
                </div>
                <div class="mx-2">
                  <b-form-group id="fieldset-horizontal" label-cols-sm="5" label-cols-lg="5" label="Show" label-for="input-horizontal" class="text-rightmr-5">
                    <b-form-select v-model="perPage" :options="options" size="sm" class label="Show" id="input-horizontal"></b-form-select>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div id="gridview" class="mt-3" v-if="isView === 'grid'">
            <div class="row mx-0">
              <template v-if="appsList.length > 0">
                <div class="col-sm-4 mb-4" v-for="(app, appInd) in appsList" :key="appInd" style="padding-left: 12px !important;padding-right: 12px !important;">
                  <div class="card bg-white px-2">
                    <div class="card-header bg-white">
                      <div class="row ml-0 align-items-center d-flex justify-center">
                        <div class="col-4 align-items-center d-flex justify-center">
                          <img class="img-thumbnail" src="../assets/img/logo/002-heart.png" style="width:50%;" />
                        </div>
                        <div class="col-6">
                          <h5 class="app_id_sect" v-if="countryName !== 'India'">
                            App Id : <span class="">{{app.appId}}</span>
                          </h5>
                        </div>
                        <div class="col-2">
                          <div class="actionDiv float-right dropdown-toggle" id="gridViewActionBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                          </div>
                          <div class="dropdown-menu" aria-labelledby="gridViewActionBtn" v-if="app.category.toLowerCase() === 'dashboard'">
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, app.category, true)">
                              <img src="../assets/img/icons/expression_builder_active.png" alt="" class="mr-2 sidebar_icon">
                              Access Dashboard
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/wizard/setup')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/rsz_edit_new_active.png" alt="" class="mr-2 sidebar_icon">
                              Edit
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/indicatorAdd')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/indicator.png" alt="" class="mr-2 sidebar_icon">
                              Indicator
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/outlierAdd')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/alert.png" alt="" class="mr-2 sidebar_icon">
                              Alert
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/organisationGroup')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/access.png" alt="" class="mr-2 sidebar_icon">
                              Location Group
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/organisationUnit')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/gml_update_g.png" alt="" class="mr-2 sidebar_icon">
                              GML Update
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/deleteMetaData')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/delete.png" alt="" class="mr-2 sidebar_icon">
                              Delete Metadata
                            </a>
                          </div>
                          <div class="dropdown-menu" aria-labelledby="gridViewActionBtn" v-else>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.username, app.category, true)">
                              <img src="../assets/img/icons/expression_builder_active.png" alt="" class="mr-2 sidebar_icon">
                              Access Dashboard
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/training_wizard')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/rsz_edit_new_active.png" alt="" class="mr-2 sidebar_icon">
                              Edit
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-body bg-white">
                      <div class="row mx-0">
                        <div class="col-12 px-0">
                          <div class="d-flex formFilledElement" style="flex-direction:column;">
                            <div>
                              <p>
                                <b>Name: <span class="pl-1"><b>{{app.appName}}</b></span></b>
                              </p>
                            </div>
                            <div>
                              <p>
                                Catagory: <span class="pl-1 ">{{ app.category }}</span>
                              </p>
                            </div>
                            <div>
                              <p>
                                Created On: <span class="pl-1 ">{{ app.createdOn }}</span>
                              </p>
                            </div>
                            <div>
                              <p>
                                Created By: <span class="pl-1 ">{{ app.createdBy }}</span>
                              </p>
                            </div>
                            <div>
                              <p>
                                Updated On: <span class="pl-1 ">{{ app.updatedOn }}</span>
                              </p>
                            </div>
                            <div>
                              <p>
                                Updated By: <span class="pl-1 ">{{ app.updatedBy }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="center-margin">
                  No Apps Found!
                </div>
              </template>
            </div>
          </div>
          <div id="tableview" class="mt-3" v-if="isView === 'list'">
            <table class="table table-striped table-hover table-responsive-sm bg-white" style="border: 1px solid #f0f0f0; border-radius: 10px; box-shadow: 0px 0px 2px #ddd;border-bottom: 0;">
              <thead class="text-white" style="background:#273649;">
                <tr>
                  <th class="text-white" style="border-top-left-radius: 10px; border-top:0;" v-if="countryName !== 'India'">App Id</th>
                  <th class="text-white">App Name</th>
                  <th class="text-white">Catagory</th>
                  <th class="text-white sortIconAfter">Created On <img src="../assets/img/icons/sort_svg.svg" class="" /></th>
                  <th class="text-white sortIconAfter">Created By <img src="../assets/img/icons/sort_svg.svg" class="" /></th>
                  <th class="text-white">Updated On</th>
                  <th class="text-white sortIconAfter">Updated By <img src="../assets/img/icons/sort_svg.svg" class="" /></th>
                  <th class="text-white" style="border-top-right-radius: 10px;  border-top:0;">Action</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="allAppsList.length > 0">
                  <template v-if="appsList.length > 0">
                    <tr v-for="(app, appInd) in appsList" :key="appInd">
                      <td v-if="countryName !== 'India'">{{ app.appId }}</td>
                      <td>{{ app.appName }}</td>
                      <td>{{ app.category }}</td>
                      <td>{{ app.createdOn }}</td>
                      <td>{{ app.createdBy }}</td>
                      <td>{{ app.updatedOn }}</td>
                      <td>{{ app.updatedBy }}</td>
                      <td>
                        <div class="dropdown selectDropDown">
                          <a class="dropdown-toggle text-success" data-toggle="dropdown">Select</a>
                          <div class="dropdown-menu" v-if="app.category.toLowerCase() === 'dashboard'">
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, app.category, true)">
                              <img src="../assets/img/icons/expression_builder_active.png" alt="" class="mr-2 sidebar_icon">
                              Access Dashboard
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/wizard/setup')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/rsz_edit_new_active.png" alt="" class="mr-2 sidebar_icon">
                              Edit
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/indicatorAdd')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/expression_builder_active.png" alt="" class="mr-2 sidebar_icon">
                              Indicator
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/outlierAdd')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/alert.png" alt="" class="mr-2 sidebar_icon">
                              Alert
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/organisationGroup')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/access.png" alt="" class="mr-2 sidebar_icon">
                              Location Group
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/organisationUnit')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/gml_update_g.png" alt="" class="mr-2 sidebar_icon">
                              GML Update
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/deleteMetaData')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/delete.png" alt="" class="mr-2 sidebar_icon">
                              Delete Metadata
                            </a>
                          </div>
                          <div class="dropdown-menu" v-else>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.username, app.category, true)">
                              <img src="../assets/img/icons/expression_builder_active.png" alt="" class="mr-2 sidebar_icon">
                              Access Dashboard
                            </a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="gotoApp(app.appId, app.appUserId, '/training_wizard')" v-if="(isAdmin || isAppAdmin)">
                              <img src="../assets/img/icons/rsz_edit_new_active.png" alt="" class="mr-2 sidebar_icon">
                              Edit
                            </a>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="8" class="text-center">No Apps Found!</td>
                    </tr>
                  </template>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="8" class="text-center">No Apps Found!</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="mt-3" v-if="appsList.length > 0">
            <b-pagination v-model="currentPage" :total-rows="allAppsListLen" :per-page="perPage" first-text="First" prev-text="Prev" next-text="Next" last-text="Last" align="center"></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import HeaderNew from "../components/layout/HeaderNew";
import trainingFooter from "../components/trainingFooter";
import ApiServices from "../service/ApiServices";
export default {
  components: {
    HeaderNew,
    trainingFooter
  },
  data() {
    return {
      userProfile: "",
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      trainingDashboardUrl: "https://vizibuzz.duredemos.com/training/",
      options: [
        // { value: null, text: "Please select an option", disabled: true },
        {
          value: "10",
          text: "10"
        },
        {
          value: "50",
          text: "50"
        },
        {
          value: "100",
          text: "100"
        },
        {
          value: "500",
          text: "500"
        }
      ],
      perPage: 10,
      currentPage: 1,
      allAppsList: [],
      searchName: "",
      isView: "list",
      allAppsListLen: 0,
      appType: 'dashboard',
      isAdmin: false,
      isAppAdmin: false,
      canCreateApp: false,
      countryName: "",
    };
  },
  computed: {
    appsList() {
      let filteredApps = this.allAppsList.filter(
        a =>
        (a.appName && a.appName.toLowerCase().includes(this.searchName.toLowerCase())) ||
        (a.createdBy && a.createdBy.toLowerCase().includes(this.searchName.toLowerCase())) ||
        (a.updatedBy && a.updatedBy.toLowerCase().includes(this.searchName.toLowerCase()))
      )
      // console.log("filteredApps",filteredApps)
      this.allAppsListLen = filteredApps.length
      return filteredApps.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    rows() {
      return this.allAppsList.length;
    }
  },
  methods: {
    createApp() {
      if (this.appType === 'dashboard') {
        this.$router.push('/createApplication/setup')
      } else {
        // this.$swal.fire({
        //   title: 'Coming Soon!',
        //   icon: "info",
        //   type: 'info'
        // })
        this.$router.push('/training_wizard')
      }
    },
    gotoApp(appId, appUserId, category, outSideRoute = false) {
      if (outSideRoute) {
        let userDetails = localStorage.getItem("authToken")
        let url = category.toLowerCase() === 'dashboard' ? `${this.dashboardUrl}?appId=${appId}&appUserId=${appUserId}` : `${this.trainingDashboardUrl}?appId=${appId}&appUserId=${appUserId}&userDetails=${userDetails}`

        if (process.env.NODE_ENV !== 'production') {
          url = category.toLowerCase() === 'dashboard' ? `http://localhost:8080/#/?appId=${appId}&appUserId=${appUserId}` : `http://localhost:8081/training/?appId=${appId}&appUserId=${appUserId}&userDetails=${userDetails}`
        }
        console.log("url", url)
        window.location.href = url
      } else {
        sessionStorage.setItem('appId', appId)
        sessionStorage.setItem('appUserId', appUserId)
        this.$nextTick(() => {
          this.$router.push(category)
        })
      }
    },
    logout() {
      //dhis-web-commons-security/logout.action
      localStorage.removeItem("userProfile");
      localStorage.removeItem("loggedInUserId");
      ApiServices.RestGetCall(
        "dhis-web-commons-security/logout.action", {}
      ).then(res => {
        console.log(res);
      });
      //window.open('http://intraavenir.duredemos.com/service/dhis-web-commons-security/logout.action', '_blank');
      this.$router.push("/");
    },
    getAllApps() {
      // console.log(this.$root)
      this.$root.loading = true
      ApiServices.getAllKeys().then(async response => {
        // console.log(response)
        let filteredApps = [],
          trainingAppCount = 0,
          dashboardAppCount = 0

        response.data.forEach(a => {
          let keyName = a.split("_");
          if (a.includes("applicationModule") && keyName.includes("en")) {
            filteredApps.push(a);
          }
        });

        await ApiServices.RestGetCall("/api/avenir/training/getTrainingApps").then(response => {
          let traningApps = response.trainingApp
          if (!Array.isArray(traningApps)) {
            traningApps = traningApps.replace(/'/g, '"');
            traningApps = JSON.parse(traningApps);
          }
          // console.log("Training response", traningApps)
          if (traningApps.length > 0) {
            traningApps.forEach(t => {
              if (this.isAdmin) {
                trainingAppCount += 1
                this.allAppsList.push(t)
              } else {
                if (this.userProfile.appIds.includes(t.appId)) {
                  trainingAppCount += 1
                  this.allAppsList.push(t)
                }
              }
            })
          }
        })
        // console.log("filteredApps", filteredApps)
        // console.log("this.allAppsList", this.allAppsList)
        // console.log("dashboardAppCount", dashboardAppCount)
        // console.log("trainingAppCount", trainingAppCount)
        if (filteredApps.length) {
          filteredApps.forEach(async (f, i) => {
            let appResponse = await ApiServices.getSavedConfig(f)
            if (this.isAdmin) {
              dashboardAppCount += 1
              this.allAppsList.push(appResponse.data)
            } else {
              if (this.userProfile.appIds && this.userProfile.appIds.includes(appResponse.data.appId)) {
                dashboardAppCount += 1
                this.allAppsList.push(appResponse.data)
              }
            }
            if (this.allAppsList.length === (dashboardAppCount + trainingAppCount)) {
              this.$root.loading = false
              console.log("apps List", this.allAppsList)
            }
          })
        } else {
          this.$root.loading = false
          console.log("No Apps created...")
        }
      }).catch(res => (this.$root.loading = false));
    }
  },
  mounted() {
    this.countryName = settings.countryName
    this.userProfile = JSON.parse(localStorage.getItem("userProfile"));
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;

    if (settings.userRole.includes(this.userProfile.userrole)) {
      this.isAdmin = true
    } else {
      if (["appAdmin"].includes(this.userProfile.userrole)) {
        this.isAppAdmin = true
      }
    }
    if (settings.countryName === "" && this.isAdmin) {
      this.canCreateApp = true
    }
    this.getAllApps();
  }
};
</script>
<style scoped lang="scss">
.mainWrap-bg {
    background-color: #f4f4f4 !important;
    background-image: none;
    // height: 100%;
    // justify-content: center;
    // display: flex;
    /* background-size: cover;
  background-position: center; */
    min-height: 100%;
    /* padding: 20px 40px; */
}
.maindivWrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80vh;
}

.form-control {
    background-color: transparent !important;
}
#gridview .dropdown-toggle::after {
    display: none;
}
.dropdown-menu {
    transform: translate3d(-110px, 18px, 0px) !important;
    transform: translate3d(-149px, 18px, 0px) !important;
    width: 200px;
}
.selectDropDown .dropdown-item {
    padding: 1rem 1rem !important;
    font-size: 14px;
    width: 100%;
    white-space: break-spaces;
    border-bottom: 1px solid #e8e8e8;
    img {
        width: 15px;
    }
}
table tbody {
    border-radius: 0 0 10px 10px;
}
table tbody tr:last-child td:nth-last-child(1) {
    border-radius: 0 0 10px 0;
}
table tbody tr:last-child td:nth-last-child(8) {
    border-radius: 0 0 0 10px;
}
</style>
